import { utf16Length } from "./string-validation"
import { z } from "zod"

export const PERSON_NAME_MAX_LENGTH = 200

export function createRequiredPersonNameSchema(label: string) {
	return z
		.string()
		.trim()
		.min(1, `${label} is required.`)
		.apply(utf16Length("max", PERSON_NAME_MAX_LENGTH, `${label} must be ${PERSON_NAME_MAX_LENGTH} characters or fewer.`))
}

export const PersonNameSchema = createRequiredPersonNameSchema("Name").meta({ id: "PersonName" })

export type PersonName = z.infer<typeof PersonNameSchema>
